export const LEVELS = ['Novice', 'Junior', 'Senior', 'Lead', 'Expert', 'Master'];
export const PEER_LEVELS = ['Trainee', 'Junior', 'Senior', 'Lead', 'Manager', 'Director'];
export const SCOPE_OF_WORK = ['Product', 'UX design', 'Tech', 'UI design'];
export const API_URL = process.env.REACT_APP_API_URL || '/api'; // set env variable
export const AUTH_URL = process.env.REACT_APP_AUTH_URL || '/auth';
export const PUBLIC_FOLDER = process.env.PUBLIC_URL;
